<template>
<div>
    <v-dialog v-model="$store.state.main.cardContractorsAddressesOpened" width="800px">
        <v-card>
            <v-card-title class="grey lighten-4 py-4 title">
                Нова адреса виконавця
            </v-card-title>
            <v-container grid-list-sm pa-4 fluid>
                <v-layout row wrap flex-wrap>
                    <v-flex xs12>
                        <v-autocomplete prepend-icon="perm_identity" label="Виконавець" v-model="f.contractorId" data-vv-name="contractorName" data-vv-as="Виконавець" v-validate="'required'" :error-messages="errors.collect('contractorName')" :loading="loadingContractor" :items="itemsContractor" :search-input.sync="searchContractor" cache-items flat hide-no-data></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-autocomplete label="Місто" v-model="f.city" data-vv-name="selectCity" data-vv-as="Місто" v-validate="'required'" :error-messages="errors.collect('selectCity')" :loading="loadingCity" :items="itemsCity" :search-input.sync="searchCity" cache-items flat hide-no-data prepend-icon="business"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field field prepend-icon="mail" label="Адреса" v-model="f.address"></v-text-field>
                    </v-flex>

                </v-layout>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="cardClose()">Скасувати</v-btn>
                <v-btn flat @click="submit" :disabled="submitDisable">Зберегти</v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
        <v-icon color="white">{{snackbarIcon}}</v-icon> {{snackbarText}}
    </v-snackbar>
</div>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {},
    props: {},
    data: function () {
        return {
            error: [],
            f: {},
            loadingContractor: false,
            itemsContractor: [],
            searchContractor: null,

            loadingCity: false,
            itemsCity: [],
            searchCity: null,

            submitDisable: false,

            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            snackbarIcon: '',
            timeout: 6000

        }
    },
    watch: {
        searchContractor(val) {
            val && val !== this.select && this.querySelectionsContractor(val)
        },
        searchCity(val) {
            val && val !== this.select && this.querySelectionsCity(val)
        },

    },
    methods: {
        cardClose() {
            this.$store.commit('openCloseContractorsAddresses', false)
            this.$validator.reset()
            this.$root.$emit('reloadContractorsAddressesTable');
        },

        querySelectionsContractor(v) {
            if (this.searchContractor.length > 2) {
                this.loadingContractor = true
                HTTP.get(`/contractors/search/?q=` + this.searchContractor)
                    .then(response => {
                        if (response.status == 200 && response.data && response.data.data) {
                            this.itemsContractor = response.data.data
                        }
                    })
                    .catch(e => {
                        this.error.push(e)
                    })
                    .finally(
                        () => {
                            this.loadingContractor = false
                        }
                    )
            }

        },
        querySelectionsCity(v) {
            if (this.searchCity.length > 2) {

                this.loadingCity = true
                HTTP.get(`/layout/search_city/?q=` + this.searchCity)
                    .then(response => {
                        if (response.status == 200 && response.data && response.data.data) {
                            this.itemsCity = response.data.data
                        }
                    })
                    .catch(e => {
                        this.error.push(e)
                    })
                    .finally(
                        () => {
                            this.loadingCity = false
                        }
                    )
            }

        },

        submit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitDisable = true
                    HTTP.post('/contractors_addresses/new_card', {
                            fields: this.f
                        }).then(response => {

                            if (response.status == 200 && response.data && response.data.status == 'ok') {
                                this.cardClose()
                                //reset $data
                                Object.assign(this.$data, this.$options.data.call(this))

                                this.snackbarText = 'Успiшно завантажено'
                                this.snackbarColor = 'info'
                                this.snackbarIcon = 'done_outline'

                            } else {
                                this.snackbarText = 'Помилка ' + (response.data.error ? response.data.error : '500')
                                this.snackbarColor = 'error'
                                this.snackbarIcon = 'error'
                            }

                        }).catch(e => {
                            this.snackbarText = 'Помилка: 500'
                            this.snackbarColor = 'error'
                            this.snackbarIcon = 'error'
                        })
                        .finally(
                            () => {
                                this.submitDisable = false
                                this.snackbar = true
                            }
                        )
                }
            })
        },

    },
    mounted() {
        this.$validator.localize('uk', this.dictionary)
    },
}
</script>
